import { getMangoApiClient } from '~/atoms/MangoApi'

import { createAiConfigApi } from '@mangovoice/ai-configuration'

export const aiConfigApi = createAiConfigApi(
  getMangoApiClient().aiConfiguration,
)
